/**
 * Renders a JSON-LD structured-data <script> tag. Kept as a plain
 * component (not routed through TanStack Router's head() `scripts` API)
 * because that API's shape for *inline* script content isn't documented
 * at this router version — a standard dangerouslySetInnerHTML script tag
 * is the well-established way to emit JSON-LD from React regardless.
 */
export function JsonLd({ data }: { data: Record<string, unknown> }) {
  return (
    <script
      type="application/ld+json"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data) }}
    />
  )
}
